export default __webpack_public_path__ + "locales/lv/VersionHistory.json?hash=e695e6b9d12a3156b1f3a42a974ab16a";